@if (this.ValidationErrors.size > 0) {
<div class="row mb-3">
  <div class="col-12">
    <div class="alert alert-danger mb-0" role="alert">
      <ul>
        @for (itemMessages of this.ValidationErrors.entries(); track itemMessages) {
        <li>
          {{ itemMessages[0] }}
          <ul>
            @for (message of itemMessages[1]; track message) {
            <li>
              {{ message }}
            </li>
            }
          </ul>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
}
<div class="flex-column flex-fill">
  <ag-grid-angular
    style="height: 100%"
    class="ag-theme-balham ag-wrap-header-text ag-highlighted-group-headers"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    [groupDefaultExpanded]="-1"
    [getContextMenuItems]="gridOptions.getContextMenuItems"
    (cellValueChanged)="onRowValueChanged($event)"
    (gridSizeChanged)="onGridSizeChanged($event)">
  </ag-grid-angular>
</div>